module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div id="floorplan_list" class="fp-list-style1">\n    ';
 var idx = -1 
__p+='\n    ';
 groups.forEach(function(v, k) { 
__p+='\n    ';

        idx += 1;

        var bedHeadClass = ["bed-header"],
            fpListClass = ["floorplan-list-items", "list-unstyled", "lined-list", "collapse"];

        if (openGroups.has(k)) {
            fpListClass.push("in");
        } else {
            bedHeadClass.push("collapsed");
        }
    
__p+='\n    <div\n        class="'+
((__t=( bedHeadClass.join(' ') ))==null?'':__t)+
'"\n        data-target="#collapse-'+
((__t=( idx ))==null?'':__t)+
'"\n        id="fp_heading_'+
((__t=( idx ))==null?'':__t)+
'"\n        aria-expanded="true"\n        aria-controls="collapse-'+
((__t=( idx ))==null?'':__t)+
'"\n        data-group="'+
((__t=( k ))==null?'':__t)+
'"\n    >\n        <span class="open-close icon-minus"></span>\n        <h4>'+
((__t=( k ))==null?'':_.escape(__t))+
'</h4>\n    </div>\n    <ul\n        id="collapse-'+
((__t=( idx ))==null?'':__t)+
'"\n        class="'+
((__t=( fpListClass.join(' ') ))==null?'':__t)+
'"\n        data-group="'+
((__t=( k ))==null?'':__t)+
'"\n    >\n        ';
 v.forEach(function(fp) { 
__p+='\n        ';
 var bed = fp.get("bed") 
__p+='\n        ';
 var image = fp.get("image") 
__p+='\n        ';
 var rent = fp.get("rent") 
__p+='\n        ';
 var deposit = fp.get("deposit") 
__p+='\n        ';

            var classList = ["fp"];
            if (fp.hasUnitPromo()) {
                classList.push("has-unit-promo");
            }
        
__p+='\n        <li class="'+
((__t=( classList.join(" ") ))==null?'':__t)+
'" id="fp'+
((__t=( fp.get('id') ))==null?'':__t)+
'">\n            ';
 if (fp.hasUnitPromo()) { 
__p+='\n                <img class="promo-tag fp-listing-promo-tag" src="/static/images/svg/promo-tag.svg" alt="promo tag icon" />\n            ';
 } 
__p+='\n            <span data-target="#fp_view_units" aria-controls="units" role="tab">\n                <div class="fp-info">\n                    ';
 if (image && showFloorplanThumbnail) { 
__p+='\n                    <div class="fp-list-image">\n                        <img src="'+
((__t=( image ))==null?'':__t)+
'" />\n                    </div>\n                    ';
 } 
__p+='\n                    <div>\n                        <h3>'+
((__t=( fp.get("name") ))==null?'':__t)+
'</h3>\n                        <div class="fp-detailed-info">\n                            <p class="beds">\n                                ';
 if (bed) { 
__p+='\n                                <span>'+
((__t=( bed ))==null?'':__t)+
'</span> <b>Bed</b>\n                                ';
 } else { 
__p+='\n                                <b>'+
((__t=( fp.get("display_bed") ))==null?'':__t)+
'</b>\n                                ';
 } 
__p+='\n                            </p>\n                            <p class="baths">\n                                <span>'+
((__t=( fp.get("bath") ))==null?'':__t)+
' </span>\n                                <b>Bath</b>\n                            </p>\n                            <p class="sqft">\n                                <b>Sq ft:</b>\n                                <span>'+
((__t=( fp.get("sq_ft") ))==null?'':__t)+
'</span>\n                            </p>\n                            ';
 if (displayRent && rent) { 
__p+='\n                                <p class="fp-rent">\n                                    <b>Rent:&nbsp;</b>\n                                    ';
 if (fp.get("promo")) { 
__p+='\n                                        <s>'+
((__t=( rent ))==null?'':__t)+
'</s>\n                                        <span> '+
((__t=( fp.get("promo") ))==null?'':__t)+
'</span>\n                                    ';
 } else { 
__p+='\n                                        <span>'+
((__t=( rent ))==null?'':__t)+
'</span>\n                                    ';
 } 
__p+='\n                                </p>\n                            ';
 } 
__p+='\n                            ';
 if (displayDeposit && deposit) { 
__p+='\n                                <p class="fp-deposit">\n                                    <b>Deposit:&nbsp;</b>\n                                    <span>'+
((__t=( deposit ))==null?'':__t)+
'</span>\n                                </p>\n                            ';
 } 
__p+='\n                        </div>\n                    </div>\n                    ';
 var units = fp.getUnits(); 
__p+='\n                    ';
 var availabilityLink = fp.getAvailabilityLink(); 
__p+='\n                    ';
 var hideUnitAvailability = fp.getHideUnitAvailability(); 
__p+='\n                    ';
 if (units.length || availabilityLink) { 
__p+='\n                        <p class="available-count">\n                            ';
 if (!hideUnitAvailability && units.length) { 
__p+='\n                                ';
 var maxUnits = fp.get("units_to_show") 
__p+='\n                                ';
 if (maxUnits && maxUnits < units.length) { 
__p+='\n                                    <span class="num-avail-count">'+
((__t=( maxUnits ))==null?'':__t)+
'</span>\n                                ';
 } else { 
__p+='\n                                    <span class="num-avail-count">'+
((__t=( units.length ))==null?'':__t)+
'</span>\n                                ';
 } 
__p+='\n\n                                <span class="status-avail-count">'+
((__t=( availabilityString ))==null?'':__t)+
'</span>\n                            ';
 } else if (availabilityLink) { 
__p+='\n                                <span class="status-avail-count">\n                                    <a\n                                        class="wait-list-link"\n                                        target="_blank"\n                                        href="'+
((__t=( availabilityLink ))==null?'':__t)+
'"\n                                    >\n                                        '+
((__t=( applyString ))==null?'':__t)+
'\n                                    </a>\n                                </span>\n                            ';
 } 
__p+='\n                        </p>\n                    ';
 } 
__p+='\n                </div>\n                <span class="icon-font icon-arrow-right"></span>\n            </span>\n        </li>\n        ';
 }) 
__p+='\n    </ul>\n    ';
 }) 
__p+='\n</div>\n';
}
return __p;
};
